"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext } from "react";
import { useSite } from "@/contexts/site/site.context";
import { useCurrentUrl } from "@/hooks/use-current-url.hook";
import type { AuthenticationProviderProps } from "@/vendors/authentication/contexts/AuthenticationProvider.context";
import type { UseAuthentication } from "@/vendors/authentication/hooks/use-authentication.hook";
import { auth0Strategy } from "../auth0.strategy";
export const Auth0UserContext = createContext<undefined | UseAuthentication>(undefined);
export function Auth0UserProvider(t0) {
  const $ = _c(19);
  const {
    children,
    user
  } = t0;
  const {
    configuration,
    urls: strategyUrls
  } = auth0Strategy;
  const {
    absoluteDomainName
  } = useCurrentUrl();
  const siteModel = useSite();
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = redirect => strategyUrls.createLogin({
      redirect
    });
    t2 = redirect_0 => strategyUrls.createLogout({
      redirect: redirect_0
    });
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  let t4;
  let t5;
  if ($[2] !== absoluteDomainName) {
    t3 = redirect_1 => strategyUrls.createLogoutToLogin({
      absoluteDomainName,
      providerUrl: null,
      redirect: redirect_1
    });
    t4 = redirect_2 => strategyUrls.createProfile({
      absoluteDomainName,
      redirect: redirect_2
    });
    t5 = redirect_3 => strategyUrls.createTrial({
      absoluteDomainName,
      redirect: redirect_3
    });
    $[2] = absoluteDomainName;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] !== siteModel) {
    t6 = strategyUrls.manageAccount(siteModel);
    $[6] = siteModel;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5 || $[11] !== t6) {
    t7 = {
      createLogin: t1,
      createLogout: t2,
      createLogoutToLogin: t3,
      createProfile: t4,
      createTrial: t5,
      manageAccount: t6
    };
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const urls = t7;
  let t8;
  if ($[13] !== urls || $[14] !== user) {
    t8 = {
      configuration,
      urls,
      user
    };
    $[13] = urls;
    $[14] = user;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const provision = t8;
  let t9;
  if ($[16] !== children || $[17] !== provision) {
    t9 = <Auth0UserContext value={provision}>{children}</Auth0UserContext>;
    $[16] = children;
    $[17] = provision;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
}